<template>
<ValidationObserver v-slot="{ invalid, handleSubmit, failed }" ref="observer">
    <form class="policy-form" @submit.prevent="handleSubmit(saveCancelTerm)" novalidate>
        <div class="edit-box box-shadow policy" :class="{ 'is-locked' : !isEditMode }">
            <div class="columns no-margin-bottom">
                <div class="column">
                    <div class="edit-box__header is-clearfix">
                        <div class="edit-box__headline-wrapper is-pulled-left">
                            <h3 v-if="isEditMode">{{ $t('cancellationTerms.name') }}</h3>
                            <h3 v-if="!isEditMode" class="edit-box__headline is-inline-block">{{ termsCopy.pms_key}} : {{termsCopy.name}} </h3>
                            <ValidationProvider
                                name="termsCopy.name"
                                v-slot="{ errors }"
                                rules="required"
                            >
                                <input type="text"
                                    :class="{'is-danger': errors[0] }" :name="termsCopy.name"
                                    placeholder="Enter Name"
                                    class="edit-box--input input is-inline-block"
                                    @click="fromFieldClicked('name')"
                                    v-if="isEditMode"
                                    v-model="termsCopy.name"
                                >
                                <span v-show="errors[0]" class="help is-danger">{{ errors[0] }}</span>
                            </ValidationProvider>

                        </div>
                        <div class="edit-box__toggle-edit is-pulled-right" @click="toggleEditMode()">
                            <a class="button" v-show="!isEditMode">
                                <i class="fa fa-pencil-square-o fa-lg"
                                    aria-hidden="true"></i>
                            </a>
                            <a class="button" v-show="isEditMode"><i class="fa fa-times fa-lg" aria-hidden="true"></i></a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="edit-box__section"  v-if="isEditMode">
                <div class="policy__condition">
                    <table class="table">
                        <tbody>
                            <tr v-for="(condition, index) in termsCopy.result" :key="index">
                                <td>

                                    <span>{{ $t('cancellationTerms.condition.part1') }}</span>
                                    <ValidationProvider
                                        name="termsCopy.result[index].cancel_days"
                                        v-slot="{ errors }"
                                        rules="required"
                                    >
                                        <input
                                            min="0"
                                            :class="{'is-danger': errors[0] }"
                                            name="termsCopy.result[index].cancel_days"
                                            class="input edit-box__inline-input is-price"
                                            v-model="termsCopy.result[index].cancel_days"
                                            type="number"
                                            id="cancel_days"
                                            @click="fromFieldClicked('cancel_days')"
                                        >
                                        <span v-show="errors[0]" class="help is-danger is-danger-inline">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                    <span>{{ $t('cancellationTerms.condition.part2') }}</span>
                                    <ValidationProvider
                                        name="termsCopy.result[index].booking_span"
                                        v-slot="{ errors }"
                                        rules="required"
                                    >
                                        <span class="select">
                                            <select id="termsCopy.result[index].booking_span"
                                                :class="{'is-danger': errors[0] }"
                                                @click="fromFieldClicked('booking_span')"
                                                v-model="termsCopy.result[index].booking_span"
                                                name="termsCopy.result[index].booking_span">
                                                <option v-for="value in periods" :value="value.name" :key="value.code">
                                                    {{ translateBookingSpanText(value.name) }}
                                                </option>
                                            </select>
                                        </span>
                                        <span v-show="errors[0]" class="help is-danger is-danger-inline">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                    <span>{{ $t('cancellationTerms.condition.part3') }}</span>

                                    <ValidationProvider
                                        name="termsCopy.result[index].amount"
                                        v-slot="{ errors }"
                                        rules="required"
                                    >
                                        <input
                                            :class="{'is-danger': errors[0] }"
                                            class="input edit-box__inline-input is-price"
                                            v-model="termsCopy.result[index].amount"
                                            type="number" id="amount"
                                            @click="fromFieldClicked('amount')"
                                        >
                                        {{  $t('cancellationTerms.percent') }}
                                        <span v-show="errors[0]" class="help is-danger is-danger-inline">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                    <span>
                                        <input
                                        class="edit-box__inline-input"
                                        type="checkbox" id="applies_for_accommodation"
                                        v-model="termsCopy.result[index].minimum_checkbox"
                                        @click="fromFieldClicked('minimum_checkbox')"
                                        name="applies_for_accommodation">
                                    </span>
                                    {{ termsCopy.result[index].minimum_checkbox ? ',' : '' }}
                                    <span :class="{ 'is-disabled' : !termsCopy.result[index].minimum_checkbox }">
                                       {{ $t('cancellationTerms.condition.part4') }}
                                    </span>
                                    <ValidationProvider
                                        name="termsCopy.result[index].minimum_amount"
                                        v-slot="{ errors }"
                                        :rules="{required: termsCopy.result[index].minimum_checkbox}"
                                    >
                                        <input
                                            min="0"
                                            :class="{'is-danger': errors[0] }"
                                            :disabled="!termsCopy.result[index].minimum_checkbox"
                                            class="input edit-box__inline-input is-price"
                                            type="number" id="minimum_amount"
                                            v-model="termsCopy.result[index].minimum_amount"
                                            @click="fromFieldClicked('minimum_amount')"
                                        >
                                        <span v-show="errors[0]" class="help is-danger is-danger-inline">{{ errors[0] }}</span>
                                    </ValidationProvider>

                                    <ValidationProvider
                                        name="termsCopy.result[index].currency"
                                        v-slot="{ errors }"
                                        :rules="{required: termsCopy.result[index].minimum_checkbox}"
                                    >
                                        <span class="select">
                                            <select id="minimum_checkbox"
                                            :class="{'is-danger': errors[0] }"
                                            :disabled="!termsCopy.result[index].minimum_checkbox"
                                            v-model="termsCopy.result[index].currency"
                                            @click="fromFieldClicked('currency')"
                                            name="currency">
                                                <option v-for="(value) in currencies" :value="value.symbol" :key="value.code">
                                                    {{ value.symbol }}
                                                </option>
                                            </select>
                                        </span>
                                        <span v-show="errors[0]" class="help is-danger">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </td>
                                <td v-if="termsCopy.result.length > 1">
                                    <a class="button is-link is-pulled-left" @click="deleteTerm(index)">
                                        <span class="icon">
                                            <i class="fa fa-trash fa-trash__red" aria-hidden="true"></i>
                                        </span>
                                    </a>
                                </td>
                            </tr>
                            <tr v-if="isEditMode" class="no-hover">
                                <a class="button is-link is-pulled-left button__margin" @click="addCancelTerms">{{ $t('cancellationTerms.addCancellation') }}</a>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="edit-box__footer is-clearfix" v-if="isEditMode">
                <a class="button is-link is-pulled-left" v-if="termsCopy.id" @click="deletePolicy">
                    <span class="icon">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                    </span>
                    <span>{{ $t('generic.delete') }}</span>
                </a>
                <button class="button is-primary is-pulled-right"
                    :class="{ 'is-loading': isLoading, 'is-disabled': failed }">
                    {{ $t('generic.save') }}
                </button>
                <a class="button is-link is-pulled-right" @click="toggleEditMode()">{{ $t('generic.cancel') }}</a>
            </div>

            <div v-if="!isEditMode" class="show-content">
                <ul class="disc-style" v-for="(value, index) in termsCopy.result" :key="index">
                    <li>
                        <h4>{{ value.display_text }}</h4>
                    </li>
                </ul>
            </div>
        </div>
    </form>
</ValidationObserver>
</template>

<script>
    import { EventBus, Tracking } from '../../../utils';
    import { AppModel } from '../../../models';
    import { Api } from '../../../api';
    import { cloneDeep } from 'lodash';
    export default {
        name: 'cancellation-term',
        props: {
            value: {
                type: Object,
                // 'default': () => ([]),
            }
        },
        created() {
            this.termsCopy = Object.assign({}, cloneDeep(this.value));
            this.currencies = AppModel.currencies;
        },
        data() {
            return {
                isEditMode: !this.value.id,
                termsCopy: {},
                isLoading: false,
                periods: [
                    {
                        name: 'after booking',
                        code: 'after_booking'
                    },
                    {
                        name: 'before arrival',
                        code: 'before_arrival'
                    }
                ],
                apiErrors: {},
            };
        },
        computed: {
            lang() {
                return AppModel.lang;
            },
        },
        watch: {
            isEditMode(newValue, oldValue) {
                if(newValue === false) {
                    this.apiErrors = {};
                }
            },
        },
        methods: {
            translateBookingSpanText(bookingSpan) {
                if(bookingSpan === 'before arrival') {
                    return this.$t('cancellationTerms.beforeArrival');
                } else {
                    return this.$t('cancellationTerms.afterBooking');
                }
            },
            toggleEditMode() {
                this.isEditMode = !this.isEditMode;
                if(!this.isEditMode) {
                    if(!this.termsCopy.id) {
                        this.deletePolicy();
                    } else {
                        this.termsCopy = Object.assign({}, cloneDeep(this.value));
                    }
                }
                Tracking.trackEvent('Policy', 'toggleEditMode', null, null);
            },
            onUpdateStart() {
                this.isLoading = true;
            },
            deletePolicy() {
                this.$emit('delTerms');
            },
            saveCancelTerm() {
                this.$refs.observer.validate().then(result => {
                    if(this.termsCopy.id) {
                        this.updatePolicy();
                    } else {
                        this.addPolicy();
                    }

                    Api.bootstrap(true);
                }).catch(result => {
                    console.log('From invalid!', result);
                    Tracking.trackEvent('Policy', 'updatePolicy', 'formInvalid', null);
                });
            },
            generatePayload() {
                let payload = {};
                payload.result = this.termsCopy.result.map(ele => {
                    if(!ele.minimum_checkbox) {
                        delete ele.minimum_amount;
                        delete ele.currency;
                    }
                    return ele;
                });
                payload.campground_slug = AppModel.activeCampground.slug;
                payload.cancellation_summary = '';
                payload.name = this.termsCopy.name;
                if(this.termsCopy.id) {
                    payload.id = this.termsCopy.id;
                }

                return payload;
            },

            updatePolicy() {
                this.onUpdateStart();
                this.termsCopy.campground_slug = AppModel.activeCampground.slug;
                this.termsCopy.cancellation_summary = '';

                Api.policies.updatePolicy(this.generatePayload())
                    .then((response) => {
                        if(response.ok) {
                            this.onUpdateDone(response.data);
                        } else {
                            this.onUpdateFailed(response);
                        }
                    }, () => {
                        this.onUpdateFailed();
                    });
                Tracking.trackEvent('Policy', 'updatePolicy', null, null);
            },
            addPolicy() {
                this.onUpdateStart();
                this.termsCopy.campground_slug = AppModel.activeCampground.slug;
                this.termsCopy.cancellation_summary = '';
                Api.policies.addPolicy(this.generatePayload())
                    .then((response) => {
                        if(response.ok) {
                            this.termsCopy.id = response.body.id;
                            this.onUpdateDone(response.data);
                        } else {
                            this.onUpdateFailed(response);
                        }
                    }, () => {
                        this.onUpdateFailed();
                    });
                Tracking.trackEvent('Policy', 'savePolicy', null, null);
            },
            addCancelTerms() {
                let newTerms = {
                    'cancel_days': '1',
                    'booking_span': 'after booking',
                    'amount': '0',
                    'minimum_checkbox': false,
                    'minimum_amount': '',
                    'currency': '€'
                };
                this.termsCopy.result.push(newTerms);
            },
            deleteTerm(index) {
                this.termsCopy.result.splice(index, 1);
            },
            onUpdateDone(data) {
                this.isLoading = false;
                this.isEditMode = false;
                this.termsCopy = Object.assign({}, cloneDeep(data));
                this.$emit('input', data);
                EventBus.$emit(EventBus.UPDATE_CHECKS);
                EventBus.$emit(EventBus.SHOW_NOTIFICATION, { title: `<h3>${this.$t('generic.saveSuccessHeadline')}</h3>`, direction: 'Up', body: this.$t('generic.saveSuccess') });
                // Tracking.trackEvent('Policy', 'updatePolicy', 'success', null);
            },
            onUpdateFailed(response = null) {
                if(response) {
                    if(typeof response.body !== 'string') {
                        this.apiErrors = response.body;
                    } else {
                        EventBus.$emit(EventBus.SHOW_NOTIFICATION, { title: `<h3>${this.$t('errors.500.title')}</h3>`, direction: 'Up', type: 'danger', body: this.$t('errors.500.content') });
                    }
                } else {
                    EventBus.$emit(EventBus.SHOW_NOTIFICATION, { title: `<h3>${this.$t('generic.formErrorHeadline')}</h3>`, direction: 'Up', type: 'danger', body: this.$t('generic.formError') });
                }
                this.isLoading = false;
                Tracking.trackEvent('Policy', 'updatePolicy', 'failed', null);
            },
            fromFieldClicked(fieldName) {
                Tracking.trackEvent('Policy', 'formField', fieldName, null);
            }
        }
    };
</script>

<style lang="scss">
    @import 'cancellation-term.scss';
</style>



// WEBPACK FOOTER //
// src/views/components/cancellation-term/cancellationTerm.vue